import { ResponseModel } from '../../../shared/models/reponse.model';
import { ConfigurationOptions, ConfigurationOptionsResponseDto } from '../dtos/confiuration-options.dto';

export class ConfigurationOptionsResponseModel extends ResponseModel {
    private _data: ConfigurationOptionsResponseDto;
    public constructor(data: ConfigurationOptionsResponseDto) {
        super(data);
        this._data = data;
    }

    public get configurationOptions(): ConfigurationOptions {
        return { ...this._data.selections };
    }
}
